module.exports = __webpack_public_path__ + "static/img/waktu-fleksibel.a41df33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/waktu-fleksibel.png
// module id = nTtq
// module chunks = 1